import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Quiz from '../views/Quiz.vue'
import TrainingList from '../views/TrainingList.vue'
import Vip from '../views/Vip.vue'
import VipUpgrade from '../views/VipUpgrade.vue'
import DebugVip from '../views/DebugVip.vue'
import DebugNotifications from '../views/DebugNotifications.vue'
import Result from '../views/Result.vue'
import Profile from '../views/Profile.vue'
import Records from '../views/Records.vue'
import RecordDetail from '../views/RecordDetail.vue'
import Orders from '../views/Orders.vue'
import WxpayConfig from '../views/WxpayConfig.vue'
import Admin from '../views/Admin.vue'
import AdminUpload from '../views/AdminUpload.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/training',
    name: 'TrainingList',
    component: TrainingList,
    meta: { requiresAuth: true, hideTabbar: true }
  },
  {
    path: '/quiz',
    name: 'Quiz',
    component: Quiz,
    meta: { requiresAuth: true }
  },
  {
    path: '/vip',
    name: 'Vip',
    component: Vip,
    meta: { requiresAuth: true }
  },
  {
    path: '/vip/upgrade',
    name: 'VipUpgrade',
    component: VipUpgrade,
    meta: { requiresAuth: true }
  },
  {
    path: '/debug/vip',
    name: 'DebugVip',
    component: DebugVip,
    meta: { requiresAuth: true }
  },
  {
    path: '/debug/notifications',
    name: 'DebugNotifications',
    component: DebugNotifications,
    meta: { requiresAuth: true }
  },
  {
    path: '/result',
    name: 'Result',
    component: Result,
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/records',
    name: 'Records',
    component: Records,
    meta: { requiresAuth: true }
  },
  {
    path: '/record/:id',
    name: 'RecordDetail',
    component: RecordDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/orders',
    name: 'Orders',
    component: Orders,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/wxpay/config',
    name: 'WxpayConfig',
    component: WxpayConfig,
    // 使用管理后台 admin_token 鉴权，勿强制要求 H5 用户 token（便于从 admin.html 跳转）
    meta: { requiresAuth: false, hideTabbar: true }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: { requiresAuth: true, hideTabbar: true }
  },
  {
    path: '/admin/upload',
    name: 'AdminUpload',
    component: AdminUpload,
    meta: { requiresAuth: true, hideTabbar: true }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const hash = window.location.hash || ''
  if (hash.indexOf('wechat_redirect') !== -1 && /[?&]code=/.test(window.location.search)) {
    const target = window.location.origin + window.location.pathname + window.location.search + '#/login'
    window.location.replace(target)
    return
  }

  const token = localStorage.getItem('token')
  
  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else {
    store.commit('SET_PREVIOUS_ROUTE', from)
    next()
  }
})

export default router